/* tslint:disable */
/* eslint-disable */
/**
 * Bank mobility service via BOA
 * Partner\'s bank mobility service via BOA
 *
 * The version of the OpenAPI document: 8.2
 * Contact: tomas.brichta@partnersbanka.cz
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// URLSearchParams not necessarily used
// @ts-ignore

// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction,
    type EndpointOptions, // THIS IS CUSTOM
  } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * Currency code of mobility issuer other bank account
 * @export
 * @enum {string}
 */

export const BankCurrencyCodeV5x4 = {
    CZK: 'CZK'
} as const;

export type BankCurrencyCodeV5x4 = typeof BankCurrencyCodeV5x4[keyof typeof BankCurrencyCodeV5x4];


/**
 * 
 * @export
 * @interface ChangeMobilityStateRequestMobilityV8
 */
export interface ChangeMobilityStateRequestMobilityV8 {
    /**
     * 
     * @type {string}
     * @memberof ChangeMobilityStateRequestMobilityV8
     */
    'mobilityUuid': string;
    /**
     * 
     * @type {string}
     * @memberof ChangeMobilityStateRequestMobilityV8
     */
    'amosId'?: string;
}
/**
 * 
 * @export
 * @interface ChangeMobilityStateRequestV8
 */
export interface ChangeMobilityStateRequestV8 {
    /**
     * 
     * @type {Array<ChangeMobilityStateRequestMobilityV8>}
     * @memberof ChangeMobilityStateRequestV8
     */
    'mobilities': Array<ChangeMobilityStateRequestMobilityV8>;
    /**
     * 
     * @type {MobilityStatusV5x4}
     * @memberof ChangeMobilityStateRequestV8
     */
    'mobilityStatus'?: MobilityStatusV5x4;
    /**
     * 
     * @type {MobilityInternalStatusV5x4}
     * @memberof ChangeMobilityStateRequestV8
     */
    'internalStatus'?: MobilityInternalStatusV5x4;
    /**
     * 
     * @type {string}
     * @memberof ChangeMobilityStateRequestV8
     */
    'internalStatusNote'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ChangeMobilityStateRequestV8
     */
    'sendNotification': boolean;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ChangeMobilityStateResponseResultItemErrorV8 = {
    UPDATE_NOT_SAVED: 'ERROR_UPDATE_NOT_SAVED',
    MOBILITY_IN_WRONG_STATUS: 'ERROR_MOBILITY_IN_WRONG_STATUS',
    GET_MOBILITY: 'ERROR_GET_MOBILITY',
    UNEXPECTED: 'ERROR_UNEXPECTED'
} as const;

export type ChangeMobilityStateResponseResultItemErrorV8 = typeof ChangeMobilityStateResponseResultItemErrorV8[keyof typeof ChangeMobilityStateResponseResultItemErrorV8];


/**
 * 
 * @export
 * @interface ChangeMobilityStateResponseResultItemV8
 */
export interface ChangeMobilityStateResponseResultItemV8 {
    /**
     * 
     * @type {string}
     * @memberof ChangeMobilityStateResponseResultItemV8
     */
    'mobilityUuid': string;
    /**
     * 
     * @type {boolean}
     * @memberof ChangeMobilityStateResponseResultItemV8
     */
    'changed': boolean;
    /**
     * 
     * @type {Array<ChangeMobilityStateResponseResultItemErrorV8>}
     * @memberof ChangeMobilityStateResponseResultItemV8
     */
    'errors'?: Array<ChangeMobilityStateResponseResultItemErrorV8>;
}
/**
 * 
 * @export
 * @interface ChangeMobilityStateResponseV8
 */
export interface ChangeMobilityStateResponseV8 {
    /**
     * 
     * @type {Array<ChangeMobilityStateResponseResultItemV8>}
     * @memberof ChangeMobilityStateResponseV8
     */
    'result': Array<ChangeMobilityStateResponseResultItemV8>;
}
/**
 * 
 * @export
 * @interface ClientV8
 */
export interface ClientV8 {
    /**
     * Pid uuid
     * @type {string}
     * @memberof ClientV8
     */
    'pidUuid': string;
    /**
     * 
     * @type {string}
     * @memberof ClientV8
     */
    'fullName': string;
}
/**
 * 
 * @export
 * @interface CreateMobilityRequestV8
 */
export interface CreateMobilityRequestV8 {
    /**
     * 
     * @type {MobilityDirectionV5x4}
     * @memberof CreateMobilityRequestV8
     */
    'mobilityDirection': MobilityDirectionV5x4;
    /**
     * Prefix of mobility issuer other bank account.
     * @type {string}
     * @memberof CreateMobilityRequestV8
     */
    'otherBankPrefix': string;
    /**
     * Account of mobility issuer other bank account.
     * @type {string}
     * @memberof CreateMobilityRequestV8
     */
    'otherBankAccount': string;
    /**
     * Bank code of mobility issuer other bank account
     * @type {string}
     * @memberof CreateMobilityRequestV8
     */
    'otherBankCode': string;
    /**
     * 
     * @type {BankCurrencyCodeV5x4}
     * @memberof CreateMobilityRequestV8
     */
    'otherBankCurrencyCode': BankCurrencyCodeV5x4;
    /**
     * Date and time of mobility
     * @type {string}
     * @memberof CreateMobilityRequestV8
     */
    'mobilityDate': string;
    /**
     * Pid uuid
     * @type {string}
     * @memberof CreateMobilityRequestV8
     */
    'pidUuid': string;
    /**
     * Mobility issuer new account iban
     * @type {string}
     * @memberof CreateMobilityRequestV8
     */
    'selectedAccountIban': string;
    /**
     * 
     * @type {Array<MobilityScopeV5x4>}
     * @memberof CreateMobilityRequestV8
     */
    'mobilityScopes': Array<MobilityScopeV5x4>;
}


/**
 * 
 * @export
 * @interface CreateMobilityResponseV8
 */
export interface CreateMobilityResponseV8 {
    /**
     * Operation uuid
     * @type {string}
     * @memberof CreateMobilityResponseV8
     */
    'operationUuid': string;
}
/**
 * Allowed manual override statuses for a mobility document. - `PROCESSED_MANUALLY` – document was processed outside the standard automated flow. - `CANCELED` – document processing was cancelled. 
 * @export
 * @enum {string}
 */

export const DocumentManualStatusV8 = {
    PROCESSED_MANUALLY: 'PROCESSED_MANUALLY',
    CANCELED: 'CANCELED'
} as const;

export type DocumentManualStatusV8 = typeof DocumentManualStatusV8[keyof typeof DocumentManualStatusV8];


/**
 * Status of document processing
 * @export
 * @enum {string}
 */

export const DocumentStatusV5x4 = {
    NOT_PROCESSED: 'NOT_PROCESSED',
    PROCESSING_FAILED: 'PROCESSING_FAILED',
    PROCESSED: 'PROCESSED',
    PROCESSING_NOT_POSSIBLE: 'PROCESSING_NOT_POSSIBLE',
    ALREADY_PROCESSED: 'ALREADY_PROCESSED',
    INVALID_CLIENT_ACCOUNT: 'INVALID_CLIENT_ACCOUNT',
    PROCESSED_MANUALLY: 'PROCESSED_MANUALLY',
    CANCELED: 'CANCELED',
    UNKNOWN: 'UNKNOWN'
} as const;

export type DocumentStatusV5x4 = typeof DocumentStatusV5x4[keyof typeof DocumentStatusV5x4];


/**
 * 
 * @export
 * @interface DownloadMobilityRequestV8
 */
export interface DownloadMobilityRequestV8 {
    /**
     * 
     * @type {Array<string>}
     * @memberof DownloadMobilityRequestV8
     */
    'mobilitiesUuids': Array<string>;
}
/**
 * 
 * @export
 * @interface ErrorResultV5x4
 */
export interface ErrorResultV5x4 {
    /**
     * 
     * @type {HttpStatusV1x0}
     * @memberof ErrorResultV5x4
     */
    'httpStatus': HttpStatusV1x0;
    /**
     * 
     * @type {string}
     * @memberof ErrorResultV5x4
     */
    'message': string;
    /**
     * 
     * @type {Array<ErrorResultValidationErrorV5x4>}
     * @memberof ErrorResultV5x4
     */
    'validationErrors': Array<ErrorResultValidationErrorV5x4>;
    /**
     * 
     * @type {string}
     * @memberof ErrorResultV5x4
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ErrorResultV5x4
     */
    'service': string;
    /**
     * 
     * @type {boolean}
     * @memberof ErrorResultV5x4
     */
    'recoverable': boolean;
    /**
     * 
     * @type {number}
     * @memberof ErrorResultV5x4
     */
    'recoverable_after'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ErrorResultV5x4
     */
    'recoverable_attempts'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ErrorResultV5x4
     */
    'xCorrelationId'?: string;
}


/**
 * Types of validation errors
 * @export
 * @enum {string}
 */

export const ErrorResultValidationErrorTypeV5x4 = {
    INTERNAL_ERROR_CODE_LIST_MISSING_ADDITIONAL_FIELDS: 'INTERNAL_ERROR_CODE_LIST_MISSING_ADDITIONAL_FIELDS',
    INTERNAL_ERROR_CODE_LIST_MISSING_DPLUS13_AND_DPLUS30: 'INTERNAL_ERROR_CODE_LIST_MISSING_DPLUS13_AND_DPLUS30',
    INTERNAL_ERROR_CODE_LIST_DID_NOT_RESPOND: 'INTERNAL_ERROR_CODE_LIST_DID_NOT_RESPOND',
    INTERNAL_ERROR_BANK_ACCOUNT_REGISTRY_DID_NOT_RESPOND: 'INTERNAL_ERROR_BANK_ACCOUNT_REGISTRY_DID_NOT_RESPOND',
    VALIDATION_DATA_ERROR_MOBILITY_DATE_NOT_DEFINED: 'VALIDATION_DATA_ERROR_MOBILITY_DATE_NOT_DEFINED',
    VALIDATION_DATA_ERROR_MOBILITY_DATE_NOT_IN_RANGE: 'VALIDATION_DATA_ERROR_MOBILITY_DATE_NOT_IN_RANGE',
    VALIDATION_DATA_ERROR_MOBILITY_DATE_NOT_WORKING_DAY: 'VALIDATION_DATA_ERROR_MOBILITY_DATE_NOT_WORKING_DAY',
    VALIDATION_DATA_ERROR_INCORRECT_BANK_ACCOUNT: 'VALIDATION_DATA_ERROR_INCORRECT_BANK_ACCOUNT',
    VALIDATION_DATA_ERROR_MISSING_SCOPE: 'VALIDATION_DATA_ERROR_MISSING_SCOPE',
    VALIDATION_DATA_ERROR_INCORRECT_PARTNERS_ACCOUNT: 'VALIDATION_DATA_ERROR_INCORRECT_PARTNERS_ACCOUNT',
    VALIDATION_DATA_ERROR_SIMILAR_MOBILITY_EXISTS: 'VALIDATION_DATA_ERROR_SIMILAR_MOBILITY_EXISTS',
    VALIDATION_DATA_ERROR_PID_DOES_NOT_EXIST: 'VALIDATION_DATA_ERROR_PID_DOES_NOT_EXIST',
    VALIDATION_DATA_ERROR_ACCOUNT_NOT_KNOWN: 'VALIDATION_DATA_ERROR_ACCOUNT_NOT_KNOWN',
    VALIDATION_ACCOUNT_ERROR_CLIENT_IS_NOT_ADULT: 'VALIDATION_ACCOUNT_ERROR_CLIENT_IS_NOT_ADULT',
    VALIDATION_ACCOUNT_ERROR_MISSING_BIRTHDAY: 'VALIDATION_ACCOUNT_ERROR_MISSING_BIRTHDAY',
    VALIDATION_ACCOUNT_ERROR_MISSING_NAME: 'VALIDATION_ACCOUNT_ERROR_MISSING_NAME',
    VALIDATION_ACCOUNT_ERROR_MISSING_PRIMARY_ID_CARD: 'VALIDATION_ACCOUNT_ERROR_MISSING_PRIMARY_ID_CARD',
    VALIDATION_ACCOUNT_ERROR_MISSING_NATIONAL_NUMBER: 'VALIDATION_ACCOUNT_ERROR_MISSING_NATIONAL_NUMBER',
    VALIDATION_ACCOUNT_ERROR_MISSING_ADDRESS: 'VALIDATION_ACCOUNT_ERROR_MISSING_ADDRESS',
    VALIDATION_ACCOUNT_ERROR_MISSING_EMAIL: 'VALIDATION_ACCOUNT_ERROR_MISSING_EMAIL',
    VALIDATION_ACCOUNT_ERROR_MISSING_PHONE: 'VALIDATION_ACCOUNT_ERROR_MISSING_PHONE',
    VALIDATION_ACCOUNT_ERROR_CLIENT_IS_NOT_OWNER_OF_IBAN: 'VALIDATION_ACCOUNT_ERROR_CLIENT_IS_NOT_OWNER_OF_IBAN',
    VALIDATION_ACCOUNT_ERROR_ACCOUNT_IS_CLOSING: 'VALIDATION_ACCOUNT_ERROR_ACCOUNT_IS_CLOSING',
    VALIDATION_ACCOUNT_ERROR_ACCOUNT_IS_BLOCKED: 'VALIDATION_ACCOUNT_ERROR_ACCOUNT_IS_BLOCKED',
    VALIDATION_ACCOUNT_ERROR_PRODUCT_NOT_ELIGIBLE: 'VALIDATION_ACCOUNT_ERROR_PRODUCT_NOT_ELIGIBLE',
    VALIDATION_ACCOUNT_ERROR_STATUS_NOT_ELIGIBLE: 'VALIDATION_ACCOUNT_ERROR_STATUS_NOT_ELIGIBLE',
    VALIDATION_ACCOUNT_ERROR_CLIENT_NOT_OWNER: 'VALIDATION_ACCOUNT_ERROR_CLIENT_NOT_OWNER',
    VERIFICATION_ERROR_NAME_AND_BIRTHDAY: 'VERIFICATION_ERROR_NAME_AND_BIRTHDAY',
    VERIFICATION_ERROR_NATIONAL_NUMBER: 'VERIFICATION_ERROR_NATIONAL_NUMBER',
    VERIFICATION_ERROR_ID_CARD: 'VERIFICATION_ERROR_ID_CARD',
    VERIFICATION_ERROR_ADDRESS: 'VERIFICATION_ERROR_ADDRESS',
    VERIFICATION_ERROR_EMAIL: 'VERIFICATION_ERROR_EMAIL',
    VERIFICATION_ERROR_PHONE: 'VERIFICATION_ERROR_PHONE',
    INVALID_DOCUMENT_STATUS: 'INVALID_DOCUMENT_STATUS'
} as const;

export type ErrorResultValidationErrorTypeV5x4 = typeof ErrorResultValidationErrorTypeV5x4[keyof typeof ErrorResultValidationErrorTypeV5x4];


/**
 * 
 * @export
 * @interface ErrorResultValidationErrorV5x4
 */
export interface ErrorResultValidationErrorV5x4 {
    /**
     * 
     * @type {ErrorResultValidationErrorTypeV5x4}
     * @memberof ErrorResultValidationErrorV5x4
     */
    'key': ErrorResultValidationErrorTypeV5x4;
    /**
     * 
     * @type {string}
     * @memberof ErrorResultValidationErrorV5x4
     */
    'message': string;
    /**
     * 
     * @type {object}
     * @memberof ErrorResultValidationErrorV5x4
     */
    'metadata'?: object;
}


/**
 * A document (file) with binary content.
 * @export
 * @interface FileDocumentWithContentV8
 */
export interface FileDocumentWithContentV8 {
    /**
     * 
     * @type {UploadClientDocumentInfoV8}
     * @memberof FileDocumentWithContentV8
     */
    'uploadClientDocumentInfo': UploadClientDocumentInfoV8;
    /**
     * 
     * @type {File}
     * @memberof FileDocumentWithContentV8
     */
    'content': File;
}
/**
 * 
 * @export
 * @interface GetFilteredMobilitiesRequestV8
 */
export interface GetFilteredMobilitiesRequestV8 {
    /**
     * 
     * @type {MobilityFilterV8}
     * @memberof GetFilteredMobilitiesRequestV8
     */
    'filter': MobilityFilterV8;
    /**
     * 
     * @type {PageableV1x0}
     * @memberof GetFilteredMobilitiesRequestV8
     */
    'pageable': PageableV1x0;
    /**
     * 
     * @type {MobilitySortV8}
     * @memberof GetFilteredMobilitiesRequestV8
     */
    'sort'?: MobilitySortV8;
}
/**
 * 
 * @export
 * @interface GetFilteredMobilitiesResponseV8
 */
export interface GetFilteredMobilitiesResponseV8 {
    /**
     * 
     * @type {Array<GetFilteredMobilitiesResponseV8ContentInner>}
     * @memberof GetFilteredMobilitiesResponseV8
     */
    'content': Array<GetFilteredMobilitiesResponseV8ContentInner>;
    /**
     * 
     * @type {PageableResponseV1x0}
     * @memberof GetFilteredMobilitiesResponseV8
     */
    'pageable': PageableResponseV1x0;
}
/**
 * 
 * @export
 * @interface GetFilteredMobilitiesResponseV8ContentInner
 */
export interface GetFilteredMobilitiesResponseV8ContentInner {
    /**
     * 
     * @type {string}
     * @memberof GetFilteredMobilitiesResponseV8ContentInner
     */
    'mobilityUuid': string;
    /**
     * 
     * @type {MobilityDirectionV5x4}
     * @memberof GetFilteredMobilitiesResponseV8ContentInner
     */
    'mobilityDirection': MobilityDirectionV5x4;
    /**
     * 
     * @type {string}
     * @memberof GetFilteredMobilitiesResponseV8ContentInner
     */
    'otherBankPrefix': string;
    /**
     * 
     * @type {string}
     * @memberof GetFilteredMobilitiesResponseV8ContentInner
     */
    'otherBankAccount': string;
    /**
     * 
     * @type {string}
     * @memberof GetFilteredMobilitiesResponseV8ContentInner
     */
    'otherBankCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetFilteredMobilitiesResponseV8ContentInner
     */
    'selectedAccountIban': string;
    /**
     * 
     * @type {string}
     * @memberof GetFilteredMobilitiesResponseV8ContentInner
     */
    'mobilityDate': string;
    /**
     * 
     * @type {string}
     * @memberof GetFilteredMobilitiesResponseV8ContentInner
     */
    'createdAt': string;
    /**
     * 
     * @type {MobilityStatusV5x4}
     * @memberof GetFilteredMobilitiesResponseV8ContentInner
     */
    'mobilityStatus': MobilityStatusV5x4;
    /**
     * 
     * @type {string}
     * @memberof GetFilteredMobilitiesResponseV8ContentInner
     */
    'updatedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetFilteredMobilitiesResponseV8ContentInner
     */
    'documentsExist': boolean;
    /**
     * 
     * @type {ClientV8}
     * @memberof GetFilteredMobilitiesResponseV8ContentInner
     */
    'client': ClientV8;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const HttpStatusV1x0 = {
    CONTINUE: 'CONTINUE',
    SWITCHING_PROTOCOLS: 'SWITCHING_PROTOCOLS',
    PROCESSING: 'PROCESSING',
    OK: 'OK',
    CREATED: 'CREATED',
    ACCEPTED: 'ACCEPTED',
    NON_AUTHORITATIVE_INFORMATION: 'NON_AUTHORITATIVE_INFORMATION',
    NO_CONTENT: 'NO_CONTENT',
    RESET_CONTENT: 'RESET_CONTENT',
    PARTIAL_CONTENT: 'PARTIAL_CONTENT',
    MULTI_STATUS: 'MULTI_STATUS',
    ALREADY_IMPORTED: 'ALREADY_IMPORTED',
    IM_USED: 'IM_USED',
    MULTIPLE_CHOICES: 'MULTIPLE_CHOICES',
    MOVED_PERMANENTLY: 'MOVED_PERMANENTLY',
    FOUND: 'FOUND',
    SEE_OTHER: 'SEE_OTHER',
    NOT_MODIFIED: 'NOT_MODIFIED',
    USE_PROXY: 'USE_PROXY',
    SWITCH_PROXY: 'SWITCH_PROXY',
    TEMPORARY_REDIRECT: 'TEMPORARY_REDIRECT',
    PERMANENT_REDIRECT: 'PERMANENT_REDIRECT',
    BAD_REQUEST: 'BAD_REQUEST',
    UNAUTHORIZED: 'UNAUTHORIZED',
    PAYMENT_REQUIRED: 'PAYMENT_REQUIRED',
    FORBIDDEN: 'FORBIDDEN',
    NOT_FOUND: 'NOT_FOUND',
    METHOD_NOT_ALLOWED: 'METHOD_NOT_ALLOWED',
    NOT_ACCEPTABLE: 'NOT_ACCEPTABLE',
    PROXY_AUTHENTICATION_REQUIRED: 'PROXY_AUTHENTICATION_REQUIRED',
    REQUEST_TIMEOUT: 'REQUEST_TIMEOUT',
    CONFLICT: 'CONFLICT',
    GONE: 'GONE',
    LENGTH_REQUIRED: 'LENGTH_REQUIRED',
    PRECONDITION_FAILED: 'PRECONDITION_FAILED',
    REQUEST_ENTITY_TOO_LARGE: 'REQUEST_ENTITY_TOO_LARGE',
    REQUEST_URI_TOO_LONG: 'REQUEST_URI_TOO_LONG',
    UNSUPPORTED_MEDIA_TYPE: 'UNSUPPORTED_MEDIA_TYPE',
    REQUESTED_RANGE_NOT_SATISFIABLE: 'REQUESTED_RANGE_NOT_SATISFIABLE',
    EXPECTATION_FAILED: 'EXPECTATION_FAILED',
    I_AM_A_TEAPOT: 'I_AM_A_TEAPOT',
    ENHANCE_YOUR_CALM: 'ENHANCE_YOUR_CALM',
    UNPROCESSABLE_ENTITY: 'UNPROCESSABLE_ENTITY',
    LOCKED: 'LOCKED',
    FAILED_DEPENDENCY: 'FAILED_DEPENDENCY',
    UNORDERED_COLLECTION: 'UNORDERED_COLLECTION',
    UPGRADE_REQUIRED: 'UPGRADE_REQUIRED',
    PRECONDITION_REQUIRED: 'PRECONDITION_REQUIRED',
    TOO_MANY_REQUESTS: 'TOO_MANY_REQUESTS',
    REQUEST_HEADER_FIELDS_TOO_LARGE: 'REQUEST_HEADER_FIELDS_TOO_LARGE',
    NO_RESPONSE: 'NO_RESPONSE',
    BLOCKED_BY_WINDOWS_PARENTAL_CONTROLS: 'BLOCKED_BY_WINDOWS_PARENTAL_CONTROLS',
    UNAVAILABLE_FOR_LEGAL_REASONS: 'UNAVAILABLE_FOR_LEGAL_REASONS',
    REQUEST_HEADER_TOO_LARGE: 'REQUEST_HEADER_TOO_LARGE',
    INTERNAL_SERVER_ERROR: 'INTERNAL_SERVER_ERROR',
    NOT_IMPLEMENTED: 'NOT_IMPLEMENTED',
    BAD_GATEWAY: 'BAD_GATEWAY',
    SERVICE_UNAVAILABLE: 'SERVICE_UNAVAILABLE',
    GATEWAY_TIMEOUT: 'GATEWAY_TIMEOUT',
    HTTP_VERSION_NOT_SUPPORTED: 'HTTP_VERSION_NOT_SUPPORTED',
    VARIANT_ALSO_NEGOTIATES: 'VARIANT_ALSO_NEGOTIATES',
    INSUFFICIENT_STORAGE: 'INSUFFICIENT_STORAGE',
    LOOP_DETECTED: 'LOOP_DETECTED',
    BANDWIDTH_LIMIT_EXCEEDED: 'BANDWIDTH_LIMIT_EXCEEDED',
    NOT_EXTENDED: 'NOT_EXTENDED',
    NETWORK_AUTHENTICATION_REQUIRED: 'NETWORK_AUTHENTICATION_REQUIRED',
    CONNECTION_TIMED_OUT: 'CONNECTION_TIMED_OUT'
} as const;

export type HttpStatusV1x0 = typeof HttpStatusV1x0[keyof typeof HttpStatusV1x0];


/**
 * Direction of mobility
 * @export
 * @enum {string}
 */

export const MobilityDirectionV5x4 = {
    INCOMING: 'INCOMING',
    OUTGOING: 'OUTGOING'
} as const;

export type MobilityDirectionV5x4 = typeof MobilityDirectionV5x4[keyof typeof MobilityDirectionV5x4];


/**
 * 
 * @export
 * @interface MobilityFilterV8
 */
export interface MobilityFilterV8 {
    /**
     * 
     * @type {Array<MobilityDirectionV5x4>}
     * @memberof MobilityFilterV8
     */
    'mobilityDirection'?: Array<MobilityDirectionV5x4>;
    /**
     * 
     * @type {Array<MobilityStatusV5x4>}
     * @memberof MobilityFilterV8
     */
    'mobilityStatus'?: Array<MobilityStatusV5x4>;
    /**
     * 
     * @type {Array<MobilitySourceV5x4>}
     * @memberof MobilityFilterV8
     */
    'mobilitySource'?: Array<MobilitySourceV5x4>;
    /**
     * Date of creation is after or equal to this date
     * @type {string}
     * @memberof MobilityFilterV8
     */
    'createdFromInclusive'?: string;
    /**
     * Date of creation is before or equal to this date
     * @type {string}
     * @memberof MobilityFilterV8
     */
    'createdToInclusive'?: string;
    /**
     * Last update date is after or equal to this date
     * @type {string}
     * @memberof MobilityFilterV8
     */
    'updatedFromInclusive'?: string;
    /**
     * Last update date is before or equal to this date
     * @type {string}
     * @memberof MobilityFilterV8
     */
    'updatedToInclusive'?: string;
    /**
     * Date of mobility is after or equal to this date
     * @type {string}
     * @memberof MobilityFilterV8
     */
    'mobilityDateFromInclusive'?: string;
    /**
     * Date of mobility is before or equal to this date
     * @type {string}
     * @memberof MobilityFilterV8
     */
    'mobilityDateToInclusive'?: string;
    /**
     * Pid uuid
     * @type {string}
     * @memberof MobilityFilterV8
     */
    'pidUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof MobilityFilterV8
     */
    'mobilityUuid'?: string;
    /**
     * 
     * @type {Array<MobilityInternalStatusV5x4>}
     * @memberof MobilityFilterV8
     */
    'internalStatus'?: Array<MobilityInternalStatusV5x4>;
    /**
     * 
     * @type {Array<DocumentStatusV5x4>}
     * @memberof MobilityFilterV8
     */
    'documentStatus'?: Array<DocumentStatusV5x4>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const MobilityInternalStatusV5x4 = {
    PENDING_SEND_TO_ORIGINAL_BANK: 'PENDING_SEND_TO_ORIGINAL_BANK',
    SENT_TO_ORIGINAL_BANK: 'SENT_TO_ORIGINAL_BANK',
    FOUR_EYES_CHECK: 'FOUR_EYES_CHECK',
    PROCESSED: 'PROCESSED',
    REJECTED_BY_ORIGINAL_BANK: 'REJECTED_BY_ORIGINAL_BANK',
    REJECTED_BY_PARTNERS_BANK: 'REJECTED_BY_PARTNERS_BANK',
    CANCELED_BY_CLIENT: 'CANCELED_BY_CLIENT'
} as const;

export type MobilityInternalStatusV5x4 = typeof MobilityInternalStatusV5x4[keyof typeof MobilityInternalStatusV5x4];


/**
 * Single goal of mobility.   * `TRANSFER_BALANCE` – the balance should be transferred from the old account to the new one.   * `TRANSFER_ALL_STANDING_ORDERS_AND_DIRECT_DEBITS` – all standing orders and all direct debits should be transferred from the old account to the new one.   * `CANCEL_ACCOUNT` – the old account should be closed. 
 * @export
 * @enum {string}
 */

export const MobilityScopeV5x4 = {
    TRANSFER_BALANCE: 'TRANSFER_BALANCE',
    TRANSFER_ALL_STANDING_ORDERS_AND_DIRECT_DEBITS: 'TRANSFER_ALL_STANDING_ORDERS_AND_DIRECT_DEBITS',
    CANCEL_ACCOUNT: 'CANCEL_ACCOUNT'
} as const;

export type MobilityScopeV5x4 = typeof MobilityScopeV5x4[keyof typeof MobilityScopeV5x4];


/**
 * 
 * @export
 * @enum {string}
 */

export const MobilitySortNameV8 = {
    DUE_DATE: 'DUE_DATE',
    MOBILITY_DATE: 'MOBILITY_DATE',
    CREATED_AT: 'CREATED_AT',
    UPDATED_AT: 'UPDATED_AT'
} as const;

export type MobilitySortNameV8 = typeof MobilitySortNameV8[keyof typeof MobilitySortNameV8];


/**
 * Sort via given name and order type.
 * @export
 * @interface MobilitySortV8
 */
export interface MobilitySortV8 {
    /**
     * 
     * @type {MobilitySortNameV8}
     * @memberof MobilitySortV8
     */
    'name': MobilitySortNameV8;
    /**
     * 
     * @type {SortOrderTypeV1x0}
     * @memberof MobilitySortV8
     */
    'order': SortOrderTypeV1x0;
}


/**
 * Type of person who initiated mobility
 * @export
 * @enum {string}
 */

export const MobilitySourceV5x4 = {
    ONBOARDING_FIP: 'ONBOARDING_FIP',
    CLIENT_MA: 'CLIENT_MA',
    USER_BO: 'USER_BO'
} as const;

export type MobilitySourceV5x4 = typeof MobilitySourceV5x4[keyof typeof MobilitySourceV5x4];


/**
 * Current state of mobility
 * @export
 * @enum {string}
 */

export const MobilityStatusV5x4 = {
    DRAFT: 'DRAFT',
    WAITING_FOR_SIGN: 'WAITING_FOR_SIGN',
    IN_PROGRESS: 'IN_PROGRESS',
    CLOSED: 'CLOSED',
    CANCELLED: 'CANCELLED',
    WAITING_FOR_ONBOARDING_APPLICATION: 'WAITING_FOR_ONBOARDING_APPLICATION',
    SIGNATURE_PREPARATION: 'SIGNATURE_PREPARATION',
    SIGNATURE_PREPARATION_FAILED: 'SIGNATURE_PREPARATION_FAILED',
    SIGNATURE_BANK_PROCESSING: 'SIGNATURE_BANK_PROCESSING',
    SIGNATURE_BANK_PROCESSING_FAILED: 'SIGNATURE_BANK_PROCESSING_FAILED',
    EXPIRED: 'EXPIRED'
} as const;

export type MobilityStatusV5x4 = typeof MobilityStatusV5x4[keyof typeof MobilityStatusV5x4];


/**
 * Pagaeble object used for searching. Returns the state of pagination.
 * @export
 * @interface PageableResponseV1x0
 */
export interface PageableResponseV1x0 {
    /**
     * Number of the page.
     * @type {number}
     * @memberof PageableResponseV1x0
     */
    'pageNumber': number;
    /**
     * Number of records per page.
     * @type {number}
     * @memberof PageableResponseV1x0
     */
    'pageSize': number;
    /**
     * Total number of pages with this page size.
     * @type {number}
     * @memberof PageableResponseV1x0
     */
    'totalPages': number;
    /**
     * Total size of all records.
     * @type {number}
     * @memberof PageableResponseV1x0
     */
    'totalSize': number;
}
/**
 * Object for search paging.
 * @export
 * @interface PageableV1x0
 */
export interface PageableV1x0 {
    /**
     * Number of the page.
     * @type {number}
     * @memberof PageableV1x0
     */
    'pageNumber': number;
    /**
     * Maximum number of records per page.
     * @type {number}
     * @memberof PageableV1x0
     */
    'pageSize': number;
}
/**
 * Sorting order - ascendent or descendent.
 * @export
 * @enum {string}
 */

export const SortOrderTypeV1x0 = {
    ASC: 'ASC',
    DESC: 'DESC'
} as const;

export type SortOrderTypeV1x0 = typeof SortOrderTypeV1x0[keyof typeof SortOrderTypeV1x0];


/**
 * 
 * @export
 * @interface UpdateDueDateRequestV8
 */
export interface UpdateDueDateRequestV8 {
    /**
     * 
     * @type {string}
     * @memberof UpdateDueDateRequestV8
     */
    'dueDate': string;
}
/**
 * 
 * @export
 * @interface UploadClientDocumentInfoV8
 */
export interface UploadClientDocumentInfoV8 {
    /**
     * 
     * @type {Array<string>}
     * @memberof UploadClientDocumentInfoV8
     */
    'tags': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UploadClientDocumentInfoV8
     */
    'documentInfo': string;
}


/**
 * BankMobilityApi - axios parameter creator
 * @export
 */
export const BankMobilityApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Change mobility state
         * @summary Change mobility state
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {ChangeMobilityStateRequestV8} changeMobilityStateRequestV8 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeStateV8: async (xCorrelationId: string, changeMobilityStateRequestV8: ChangeMobilityStateRequestV8, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('changeStateV8', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'changeMobilityStateRequestV8' is not null or undefined
            assertParamExists('changeStateV8', 'changeMobilityStateRequestV8', changeMobilityStateRequestV8)
            const localVarPath = `/bank-backofficegateway-mobility/v8/mobility/change-state`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeMobilityStateRequestV8, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download mobilities
         * @summary Download mobilities
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {DownloadMobilityRequestV8} downloadMobilityRequestV8 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadMobilityV8: async (xCorrelationId: string, downloadMobilityRequestV8: DownloadMobilityRequestV8, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('downloadMobilityV8', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'downloadMobilityRequestV8' is not null or undefined
            assertParamExists('downloadMobilityV8', 'downloadMobilityRequestV8', downloadMobilityRequestV8)
            const localVarPath = `/bank-backofficegateway-mobility/v8/mobility/download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(downloadMobilityRequestV8, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get list of mobilities filtered by defined criteria
         * @summary Get list of mobilities filtered by defined criteria
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {GetFilteredMobilitiesRequestV8} getFilteredMobilitiesRequestV8 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilteredMobilitiesV8: async (xCorrelationId: string, getFilteredMobilitiesRequestV8: GetFilteredMobilitiesRequestV8, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('getFilteredMobilitiesV8', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'getFilteredMobilitiesRequestV8' is not null or undefined
            assertParamExists('getFilteredMobilitiesV8', 'getFilteredMobilitiesRequestV8', getFilteredMobilitiesRequestV8)
            const localVarPath = `/bank-backofficegateway-mobility/v8/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getFilteredMobilitiesRequestV8, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Processes the payments contained in a mobility document.
         * @summary Process payments from a mobility document
         * @param {string} authorization 
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} mobilityUuid 
         * @param {string} documentUuid UUID of the document whose payments are to be processed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processDocumentPaymentsV8: async (authorization: string, xCorrelationId: string, mobilityUuid: string, documentUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('processDocumentPaymentsV8', 'authorization', authorization)
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('processDocumentPaymentsV8', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'mobilityUuid' is not null or undefined
            assertParamExists('processDocumentPaymentsV8', 'mobilityUuid', mobilityUuid)
            // verify required parameter 'documentUuid' is not null or undefined
            assertParamExists('processDocumentPaymentsV8', 'documentUuid', documentUuid)
            const localVarPath = `/bank-backofficegateway-mobility/v8/mobility/{mobilityUuid}/documents/{documentUuid}/process-payments`
                .replace(`{${"mobilityUuid"}}`, encodeURIComponent(String(mobilityUuid)))
                .replace(`{${"documentUuid"}}`, encodeURIComponent(String(documentUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the processing status of a mobility document. Only transitions to `PROCESSED_MANUALLY` or `CANCELED` are allowed. 
         * @summary Update document processing status
         * @param {string} authorization 
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} mobilityUuid 
         * @param {string} documentUuid UUID of the document whose status is being updated.
         * @param {DocumentManualStatusV8} status Target status to set for the document.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDocumentStatusV8: async (authorization: string, xCorrelationId: string, mobilityUuid: string, documentUuid: string, status: DocumentManualStatusV8, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateDocumentStatusV8', 'authorization', authorization)
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('updateDocumentStatusV8', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'mobilityUuid' is not null or undefined
            assertParamExists('updateDocumentStatusV8', 'mobilityUuid', mobilityUuid)
            // verify required parameter 'documentUuid' is not null or undefined
            assertParamExists('updateDocumentStatusV8', 'documentUuid', documentUuid)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updateDocumentStatusV8', 'status', status)
            const localVarPath = `/bank-backofficegateway-mobility/v8/mobility/{mobilityUuid}/documents/{documentUuid}/statuses/{status}`
                .replace(`{${"mobilityUuid"}}`, encodeURIComponent(String(mobilityUuid)))
                .replace(`{${"documentUuid"}}`, encodeURIComponent(String(documentUuid)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload a document containing payment history from another bank.
         * @summary Upload document with other bank payments for mobility
         * @param {string} authorization 
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} mobilityUuid 
         * @param {UploadClientDocumentInfoV8} uploadClientDocumentInfo 
         * @param {File} content 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadDocumentWithPaymentsV8: async (authorization: string, xCorrelationId: string, mobilityUuid: string, uploadClientDocumentInfo: UploadClientDocumentInfoV8, content: File, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('uploadDocumentWithPaymentsV8', 'authorization', authorization)
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('uploadDocumentWithPaymentsV8', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'mobilityUuid' is not null or undefined
            assertParamExists('uploadDocumentWithPaymentsV8', 'mobilityUuid', mobilityUuid)
            // verify required parameter 'uploadClientDocumentInfo' is not null or undefined
            assertParamExists('uploadDocumentWithPaymentsV8', 'uploadClientDocumentInfo', uploadClientDocumentInfo)
            // verify required parameter 'content' is not null or undefined
            assertParamExists('uploadDocumentWithPaymentsV8', 'content', content)
            const localVarPath = `/bank-backofficegateway-mobility/v8/{mobilityUuid}/upload-document-with-payments`
                .replace(`{${"mobilityUuid"}}`, encodeURIComponent(String(mobilityUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


            if (uploadClientDocumentInfo !== undefined) { 
                localVarFormParams.append('uploadClientDocumentInfo', typeof uploadClientDocumentInfo === 'object' ? JSON.stringify(uploadClientDocumentInfo) : uploadClientDocumentInfo); // THIS IS CUSTOM
            }
    
            if (content !== undefined) { 
                localVarFormParams.append('content', content as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BankMobilityApi - functional programming interface
 * @export
 */
export const BankMobilityApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BankMobilityApiAxiosParamCreator(configuration)
    return {
        /**
         * Change mobility state
         * @summary Change mobility state
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {ChangeMobilityStateRequestV8} changeMobilityStateRequestV8 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeStateV8(xCorrelationId: string, changeMobilityStateRequestV8: ChangeMobilityStateRequestV8, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChangeMobilityStateResponseV8>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeStateV8(xCorrelationId, changeMobilityStateRequestV8, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Download mobilities
         * @summary Download mobilities
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {DownloadMobilityRequestV8} downloadMobilityRequestV8 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadMobilityV8(xCorrelationId: string, downloadMobilityRequestV8: DownloadMobilityRequestV8, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadMobilityV8(xCorrelationId, downloadMobilityRequestV8, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get list of mobilities filtered by defined criteria
         * @summary Get list of mobilities filtered by defined criteria
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {GetFilteredMobilitiesRequestV8} getFilteredMobilitiesRequestV8 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFilteredMobilitiesV8(xCorrelationId: string, getFilteredMobilitiesRequestV8: GetFilteredMobilitiesRequestV8, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFilteredMobilitiesResponseV8>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFilteredMobilitiesV8(xCorrelationId, getFilteredMobilitiesRequestV8, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Processes the payments contained in a mobility document.
         * @summary Process payments from a mobility document
         * @param {string} authorization 
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} mobilityUuid 
         * @param {string} documentUuid UUID of the document whose payments are to be processed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async processDocumentPaymentsV8(authorization: string, xCorrelationId: string, mobilityUuid: string, documentUuid: string, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.processDocumentPaymentsV8(authorization, xCorrelationId, mobilityUuid, documentUuid, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates the processing status of a mobility document. Only transitions to `PROCESSED_MANUALLY` or `CANCELED` are allowed. 
         * @summary Update document processing status
         * @param {string} authorization 
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} mobilityUuid 
         * @param {string} documentUuid UUID of the document whose status is being updated.
         * @param {DocumentManualStatusV8} status Target status to set for the document.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDocumentStatusV8(authorization: string, xCorrelationId: string, mobilityUuid: string, documentUuid: string, status: DocumentManualStatusV8, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDocumentStatusV8(authorization, xCorrelationId, mobilityUuid, documentUuid, status, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Upload a document containing payment history from another bank.
         * @summary Upload document with other bank payments for mobility
         * @param {string} authorization 
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} mobilityUuid 
         * @param {UploadClientDocumentInfoV8} uploadClientDocumentInfo 
         * @param {File} content 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadDocumentWithPaymentsV8(authorization: string, xCorrelationId: string, mobilityUuid: string, uploadClientDocumentInfo: UploadClientDocumentInfoV8, content: File, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadDocumentWithPaymentsV8(authorization, xCorrelationId, mobilityUuid, uploadClientDocumentInfo, content, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BankMobilityApi - factory interface
 * @export
 */
export const BankMobilityApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BankMobilityApiFp(configuration)
    return {
        /**
         * Change mobility state
         * @summary Change mobility state
         * @param {BankMobilityApiChangeStateV8Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeStateV8(requestParameters: BankMobilityApiChangeStateV8Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<ChangeMobilityStateResponseV8> {
            return localVarFp.changeStateV8(requestParameters.xCorrelationId, requestParameters.changeMobilityStateRequestV8, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Download mobilities
         * @summary Download mobilities
         * @param {BankMobilityApiDownloadMobilityV8Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadMobilityV8(requestParameters: BankMobilityApiDownloadMobilityV8Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<File> {
            return localVarFp.downloadMobilityV8(requestParameters.xCorrelationId, requestParameters.downloadMobilityRequestV8, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Get list of mobilities filtered by defined criteria
         * @summary Get list of mobilities filtered by defined criteria
         * @param {BankMobilityApiGetFilteredMobilitiesV8Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilteredMobilitiesV8(requestParameters: BankMobilityApiGetFilteredMobilitiesV8Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<GetFilteredMobilitiesResponseV8> {
            return localVarFp.getFilteredMobilitiesV8(requestParameters.xCorrelationId, requestParameters.getFilteredMobilitiesRequestV8, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Processes the payments contained in a mobility document.
         * @summary Process payments from a mobility document
         * @param {BankMobilityApiProcessDocumentPaymentsV8Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processDocumentPaymentsV8(requestParameters: BankMobilityApiProcessDocumentPaymentsV8Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<void> {
            return localVarFp.processDocumentPaymentsV8(requestParameters.authorization, requestParameters.xCorrelationId, requestParameters.mobilityUuid, requestParameters.documentUuid, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Updates the processing status of a mobility document. Only transitions to `PROCESSED_MANUALLY` or `CANCELED` are allowed. 
         * @summary Update document processing status
         * @param {BankMobilityApiUpdateDocumentStatusV8Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDocumentStatusV8(requestParameters: BankMobilityApiUpdateDocumentStatusV8Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<void> {
            return localVarFp.updateDocumentStatusV8(requestParameters.authorization, requestParameters.xCorrelationId, requestParameters.mobilityUuid, requestParameters.documentUuid, requestParameters.status, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Upload a document containing payment history from another bank.
         * @summary Upload document with other bank payments for mobility
         * @param {BankMobilityApiUploadDocumentWithPaymentsV8Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadDocumentWithPaymentsV8(requestParameters: BankMobilityApiUploadDocumentWithPaymentsV8Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<void> {
            return localVarFp.uploadDocumentWithPaymentsV8(requestParameters.authorization, requestParameters.xCorrelationId, requestParameters.mobilityUuid, requestParameters.uploadClientDocumentInfo, requestParameters.content, options, endpointOptions).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for changeStateV8 operation in BankMobilityApi.
 * @export
 * @type BankMobilityApiChangeStateV8Request
 */
export type BankMobilityApiChangeStateV8Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof BankMobilityApiChangeStateV8
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {ChangeMobilityStateRequestV8}
     * @memberof BankMobilityApiChangeStateV8
     */
    readonly changeMobilityStateRequestV8: ChangeMobilityStateRequestV8
}

/**
 * Request parameters for downloadMobilityV8 operation in BankMobilityApi.
 * @export
 * @type BankMobilityApiDownloadMobilityV8Request
 */
export type BankMobilityApiDownloadMobilityV8Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof BankMobilityApiDownloadMobilityV8
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {DownloadMobilityRequestV8}
     * @memberof BankMobilityApiDownloadMobilityV8
     */
    readonly downloadMobilityRequestV8: DownloadMobilityRequestV8
}

/**
 * Request parameters for getFilteredMobilitiesV8 operation in BankMobilityApi.
 * @export
 * @type BankMobilityApiGetFilteredMobilitiesV8Request
 */
export type BankMobilityApiGetFilteredMobilitiesV8Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof BankMobilityApiGetFilteredMobilitiesV8
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {GetFilteredMobilitiesRequestV8}
     * @memberof BankMobilityApiGetFilteredMobilitiesV8
     */
    readonly getFilteredMobilitiesRequestV8: GetFilteredMobilitiesRequestV8
}

/**
 * Request parameters for processDocumentPaymentsV8 operation in BankMobilityApi.
 * @export
 * @type BankMobilityApiProcessDocumentPaymentsV8Request
 */
export type BankMobilityApiProcessDocumentPaymentsV8Request = {
    /**
     * 
     * @type {string}
     * @memberof BankMobilityApiProcessDocumentPaymentsV8
     */
    readonly authorization: string

    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof BankMobilityApiProcessDocumentPaymentsV8
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {string}
     * @memberof BankMobilityApiProcessDocumentPaymentsV8
     */
    readonly mobilityUuid: string

    /**
     * UUID of the document whose payments are to be processed.
     * @type {string}
     * @memberof BankMobilityApiProcessDocumentPaymentsV8
     */
    readonly documentUuid: string
}

/**
 * Request parameters for updateDocumentStatusV8 operation in BankMobilityApi.
 * @export
 * @type BankMobilityApiUpdateDocumentStatusV8Request
 */
export type BankMobilityApiUpdateDocumentStatusV8Request = {
    /**
     * 
     * @type {string}
     * @memberof BankMobilityApiUpdateDocumentStatusV8
     */
    readonly authorization: string

    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof BankMobilityApiUpdateDocumentStatusV8
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {string}
     * @memberof BankMobilityApiUpdateDocumentStatusV8
     */
    readonly mobilityUuid: string

    /**
     * UUID of the document whose status is being updated.
     * @type {string}
     * @memberof BankMobilityApiUpdateDocumentStatusV8
     */
    readonly documentUuid: string

    /**
     * Target status to set for the document.
     * @type {DocumentManualStatusV8}
     * @memberof BankMobilityApiUpdateDocumentStatusV8
     */
    readonly status: DocumentManualStatusV8
}

/**
 * Request parameters for uploadDocumentWithPaymentsV8 operation in BankMobilityApi.
 * @export
 * @type BankMobilityApiUploadDocumentWithPaymentsV8Request
 */
export type BankMobilityApiUploadDocumentWithPaymentsV8Request = {
    /**
     * 
     * @type {string}
     * @memberof BankMobilityApiUploadDocumentWithPaymentsV8
     */
    readonly authorization: string

    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof BankMobilityApiUploadDocumentWithPaymentsV8
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {string}
     * @memberof BankMobilityApiUploadDocumentWithPaymentsV8
     */
    readonly mobilityUuid: string

    /**
     * 
     * @type {UploadClientDocumentInfoV8}
     * @memberof BankMobilityApiUploadDocumentWithPaymentsV8
     */
    readonly uploadClientDocumentInfo: UploadClientDocumentInfoV8

    /**
     * 
     * @type {File}
     * @memberof BankMobilityApiUploadDocumentWithPaymentsV8
     */
    readonly content: File
}

/**
 * BankMobilityApi - object-oriented interface
 * @export
 * @class BankMobilityApi
 * @extends {BaseAPI}
 */
export class BankMobilityApi extends BaseAPI {
    /**
     * Change mobility state
     * @summary Change mobility state
     * @param {BankMobilityApiChangeStateV8Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankMobilityApi
     */
    public changeStateV8(requestParameters: BankMobilityApiChangeStateV8Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return BankMobilityApiFp(this.configuration).changeStateV8(requestParameters.xCorrelationId, requestParameters.changeMobilityStateRequestV8, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download mobilities
     * @summary Download mobilities
     * @param {BankMobilityApiDownloadMobilityV8Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankMobilityApi
     */
    public downloadMobilityV8(requestParameters: BankMobilityApiDownloadMobilityV8Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return BankMobilityApiFp(this.configuration).downloadMobilityV8(requestParameters.xCorrelationId, requestParameters.downloadMobilityRequestV8, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get list of mobilities filtered by defined criteria
     * @summary Get list of mobilities filtered by defined criteria
     * @param {BankMobilityApiGetFilteredMobilitiesV8Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankMobilityApi
     */
    public getFilteredMobilitiesV8(requestParameters: BankMobilityApiGetFilteredMobilitiesV8Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return BankMobilityApiFp(this.configuration).getFilteredMobilitiesV8(requestParameters.xCorrelationId, requestParameters.getFilteredMobilitiesRequestV8, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Processes the payments contained in a mobility document.
     * @summary Process payments from a mobility document
     * @param {BankMobilityApiProcessDocumentPaymentsV8Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankMobilityApi
     */
    public processDocumentPaymentsV8(requestParameters: BankMobilityApiProcessDocumentPaymentsV8Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return BankMobilityApiFp(this.configuration).processDocumentPaymentsV8(requestParameters.authorization, requestParameters.xCorrelationId, requestParameters.mobilityUuid, requestParameters.documentUuid, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the processing status of a mobility document. Only transitions to `PROCESSED_MANUALLY` or `CANCELED` are allowed. 
     * @summary Update document processing status
     * @param {BankMobilityApiUpdateDocumentStatusV8Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankMobilityApi
     */
    public updateDocumentStatusV8(requestParameters: BankMobilityApiUpdateDocumentStatusV8Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return BankMobilityApiFp(this.configuration).updateDocumentStatusV8(requestParameters.authorization, requestParameters.xCorrelationId, requestParameters.mobilityUuid, requestParameters.documentUuid, requestParameters.status, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload a document containing payment history from another bank.
     * @summary Upload document with other bank payments for mobility
     * @param {BankMobilityApiUploadDocumentWithPaymentsV8Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankMobilityApi
     */
    public uploadDocumentWithPaymentsV8(requestParameters: BankMobilityApiUploadDocumentWithPaymentsV8Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return BankMobilityApiFp(this.configuration).uploadDocumentWithPaymentsV8(requestParameters.authorization, requestParameters.xCorrelationId, requestParameters.mobilityUuid, requestParameters.uploadClientDocumentInfo, requestParameters.content, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }
}


